'use strict';

const POLL_FREQUENCY = 1000 * 3, // 3 seconds
//const POLL_FREQUENCY = 1000 * 10, // 10 seconds
    RestUtils = require('./../utils/RestUtils'),
    SessionStore = require('./../stores/SessionStore'),
    DashboardStore = require('stores/DashboardStore'),
    Notification = require('components/Notification/Notification'),
    Security = require('./../services/Security').auth,
    ChronologycServiceCache = require('./../services/ChronologycServiceCache');

/**
 * The simple pulling class that auto save in pulling way notes of dashboard.
 * @type {{inProgress: boolean, intervalId: null, poll: Function, start: Function, stop: Function}}
 */
const PollerSaveNote = {

    /**
     * The flag that allow as to not pull other request after finish the previous one.
     */
    inProgress: false,
    /**
     * The native interval id that allow as to stop the cycle when we need it.
     */
    intervalId: null,

    /**
     * Auto save draft in backend side in pulling way.
     */
    poll: function (callback) {
        
        if (this._shouldPoll()) {
            const self = this;
            const ajax = RestUtils.createXHR();
            const path = process.env.URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/operations';
            const currentBrewingPendingOperations = ChronologycServiceCache.getBrewingOperations();
            const currentPackagingPendingOperations = ChronologycServiceCache.getPackagingOperations();
    
            try {
                this.inProgress = true;
                
                ajax.addEventListener('error', function (error) {
                    if (!error) {
                        error = {};
                    }
                    if (!error.type) {
                        error.type = '';
                    }
                  
                    console.error('PollerSaveNote Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
                    self.inProgress = false;
                    if (callback) {
                        callback();
                    }
                });

                /**
                 * After save notes in server side, the Publish note number will increment +1
                 * That change will produce that PollerDashboard#pool() will trigger DashboardActionCreators#needFetchNotes() action.
                 * And after that, the Chronologyc view will render with the new notes values.
                 */
                ajax.addEventListener('load', function () {
                    RestUtils.handlerResponse(this, function () {
                        DashboardStore.setIsSavedDraft();
                        ChronologycServiceCache.deleteBrewingOperationPerformed(currentBrewingPendingOperations);
                        ChronologycServiceCache.deletePackagingOperationPerformed(currentPackagingPendingOperations);
                        self.inProgress = false;
                        if (callback) {
                            callback();
                        }
                    }, function () {
                        // retry again
                        self.inProgress = false;
                    });
                });

                ajax.open('POST', path);
                ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());

                ajax.send(JSON.stringify({
                    'brewingOperations': currentBrewingPendingOperations,
                    'packagingOperations': currentPackagingPendingOperations,
                    'lastBrewingNoteNumber': SessionStore.getLastBrewingNoteNumber(),
                    'lastPackagingNoteNumber': SessionStore.getLastPackagingNoteNumber()
                }));
                Notification.show('Notes Saved', 'success', 3);
            } catch(err) {
                self.inProgress = false;
                DashboardStore.unsetIsSavedDraft();
            }
        }
    },

    /**
     * Valid if need to poll pending operations
     * @returns {boolean}
     * @private
     */
    _shouldPoll: function () {
        if (this.inProgress === true) {
            return false;
        }
        if (ChronologycServiceCache.getBrewingOperations().length > 0 || ChronologycServiceCache.getPackagingOperations().length > 0) {
            return true;
        }
        return false;
    },

    /**
     * Start pulling in order to auto save given draft.
     */
    start: function () {
        if (SessionStore.isAdminUser()) {
            this.refreshIntervalId = setInterval(this.poll.bind(this), POLL_FREQUENCY);
        }
    },

    /**
     * Stop current pulling
     */
    stop: function () {
        clearInterval(this.refreshIntervalId);
    }
};

module.exports = PollerSaveNote;



/** WEBPACK FOOTER **
 ** ./src/pollers/PollerSaveNote.js
 **/